import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  IconButton,
  BankingExportList,
  RouteWrapper,
  HeadingSection,
  Section,
  Loader,
  Pagination,
} from '../../components';
import { getBankingExports } from '../../redux/actions/payments';
import PAGINATE from '../../data/paginate';

interface Props {
  dispatch: Function;
}

interface State {
  bankingExports: Array<any>;
  isLoading: boolean;
  errorMessage: string | boolean;
  page: number;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      bankingExports: [],
      errorMessage: false,
      isLoading: true,
      page: 0,
    };
  }

  /**
   * Retrieve all bankings exports
   */
  async componentDidMount() {
    const response = await this.props.dispatch(getBankingExports());
    if (!response.error) {
      this.setState({ bankingExports: response.data, isLoading: false });
    } else {
      this.setState({ errorMessage: response.error, isLoading: false });
    }
  }

  render() {
    return (
      <RouteWrapper
        title="Banking Export"
        loading={this.state.isLoading}
        requireAuth
        requirePermission="MANAGE_PAYMENTS"
        error={this.state.errorMessage}
      >
        <HeadingSection
          title="Banking Exports"
          controls={[
            <IconButton
              key="back-button"
              icon="undo"
              className="is-default"
              handleClick={() => {
                this.props.dispatch(goBack());
              }}
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <div className="columns is-centered">
            <div className="column is-12-desktop is-7-widescreen">
              {this.state.isLoading ? (
                <Loader fullwidth />
              ) : (
                <>
                  <div className="field">
                    <BankingExportList items={this.state.bankingExports} />
                  </div>
                  <div className="field">
                    <Pagination
                      page={this.state.page}
                      lastPage={
                        this.state.bankingExports.length <=
                        PAGINATE.bankingExports.MAX
                      }
                      handleUpdate={async (page) => {
                        this.setState({ page });
                        const response = await this.props.dispatch(
                          getBankingExports(page),
                        );
                        if (!response.error) {
                          this.setState({
                            bankingExports: response.data,
                            isLoading: false,
                          });
                        } else {
                          this.setState({
                            errorMessage: response.error,
                            isLoading: false,
                          });
                        }
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </Section>
      </RouteWrapper>
    );
  }
}

export default connect()(Route);
